module.exports = __webpack_public_path__ + "static/media/bank.2e0c87b4.svg";